import sp from "../../assets/images/Footer/sp.svg";
import vid_left from "../../assets/images/Customer/vid_left.webp";
import sto_vid from "../../assets/images/Customer/sto_vid.webp";

export default function CustomerVid() {
  return (
    <div className="w-full">
      <div className="w-full container mx-auto px-[20px] py-[20px] flex flex-col gap-3">
        <div className="flex items-center gap-2">
          <img src={sp} alt="b1" />
          <p>Câu chuyện thành công từ khách hàng của chúng tôi</p>
        </div>
        <div className="w-full grid grid-cols-1 md:flex md:gap-3 gap-4">
          <div className="w-full md:w-9/12">
            <img
              src={vid_left}
              alt="vi"
              className="w-full h-auto object-cover"
            />
          </div>
          <div className="w-full md:w-3/12 h-96 ">
            <div className="scroll-container flex flex-col gap-3 md:gap-6 w-full md:overflow-x-hidden overflow-x-hidden">
              <div className="flex items-center gap-2 bg-[#E2E2E2] md:bg-white  ">
                <img
                  src={sto_vid}
                  alt="st"
                  className="w-[118px] h-[116px] md:w-full md:h-auto object-cover rounded"
                />
                <div>
                  <p className="block md:hidden w-full h-[116px] text-[13px]">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Aliquam cursus nulla vitae massa gravida, id fringilla arcu
                    rhoncus.{" "}
                  </p>
                </div>
              </div>

              <div className="flex items-center gap-2 bg-[#E2E2E2] md:bg-white  ">
                <img
                  src={sto_vid}
                  alt="st1"
                  className="w-[118px] h-[116px] md:w-full md:h-auto object-cover rounded"
                />
                <div>
                  <p className="block md:hidden w-full h-[116px] text-[13px]">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Aliquam cursus nulla vitae massa gravida, id fringilla arcu
                    rhoncus.{" "}
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-2 bg-[#E2E2E2] md:bg-white  ">
                <img
                  src={sto_vid}
                  alt="st2"
                  className="w-[118px] h-[116px] md:w-full md:h-auto object-cover rounded"
                />
                <div>
                  <p className="block md:hidden w-full h-[116px] text-[13px]">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Aliquam cursus nulla vitae massa gravida, id fringilla arcu
                    rhoncus.{" "}
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-2 bg-[#E2E2E2] md:bg-white  ">
                <img
                  src={sto_vid}
                  alt="st3"
                  className="w-[118px] h-[116px] md:w-full md:h-auto object-cover rounded"
                />
                <div>
                  <p className="block md:hidden w-full h-[116px] text-[13px]">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Aliquam cursus nulla vitae massa gravida, id fringilla arcu
                    rhoncus.{" "}
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-2 bg-[#E2E2E2] md:bg-white  ">
                <img
                  src={sto_vid}
                  alt="st4"
                  className="w-[118px] h-[116px] md:w-full md:h-auto object-cover rounded"
                />
                <div>
                  <p className="block md:hidden w-full h-[116px] text-[13px]">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Aliquam cursus nulla vitae massa gravida, id fringilla arcu
                    rhoncus.{" "}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
